import React from 'react';
import PropTypes from 'prop-types';
import config from '@plone/volto/registry';
import { withBlockExtensions } from '@plone/volto/helpers/Extensions';
import PageHeaderDefaultTemplate from './CustomImageBodyTemplate';
import Breadcrumbs from '@plone/volto/components/theme/Breadcrumbs/Breadcrumbs';
import { getBaseUrl } from '@plone/volto/helpers/Url/Url';

const PageHeaderView = (props) => {
  const { variation, properties, location } = props;
  const path = getBaseUrl(location?.pathname || '');
  const hasType = properties['@type'];

  // Compatible with the previous version of the component registry
  // and the Volto 16 one.
  const BodyComponent =
    (config?.getComponent &&
      hasType &&
      config.getComponent({ name: 'PageHeader', dependencies: [hasType] })
        .component) ||
    variation?.template ||
    PageHeaderDefaultTemplate;

  return (
    <>
      <BodyComponent {...props} breadcrumbPath={path} />
    </>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
PageHeaderView.propTypes = {
  properties: PropTypes.objectOf(PropTypes.any).isRequired,
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  isEditMode: PropTypes.bool,
};

export default withBlockExtensions(PageHeaderView);
